import {
  Calendar, Package, Users, Clock, BarChart3, Activity,
  Share2, MessageSquare, LayoutDashboard, CalendarDays,
  Settings, Dumbbell, Apple, ClipboardList,
} from "lucide-react";

export const MEAL_CONFIG = [
  { id: "breakfast", pt: "Café da Manhã", de: "Frühstück", en: "Breakfast", color: "#f59e0b", bg: "bg-amber-50", border: "border-amber-200", text: "text-amber-700", ring: "ring-amber-200" },
  { id: "lunch", pt: "Almoço", de: "Mittagessen", en: "Lunch", color: "#2563eb", bg: "bg-blue-50", border: "border-blue-200", text: "text-blue-700", ring: "ring-blue-200" },
  { id: "snack", pt: "Lanche da Tarde", de: "Nachmittags-Snack", en: "Afternoon Snack", color: "#10b981", bg: "bg-emerald-50", border: "border-emerald-200", text: "text-emerald-700", ring: "ring-emerald-200" },
  { id: "dinner", pt: "Jantar", de: "Abendessen", en: "Dinner", color: "#8b5cf6", bg: "bg-violet-50", border: "border-violet-200", text: "text-violet-700", ring: "ring-violet-200" },
  { id: "supper", pt: "Ceia", de: "Spätmahlzeit", en: "Supper", color: "#ec4899", bg: "bg-pink-50", border: "border-pink-200", text: "text-pink-700", ring: "ring-pink-200" },
  { id: "supplements", pt: "Suplementação", de: "Nahrungsergänzung", en: "Supplements", color: "#0ea5e9", bg: "bg-sky-50", border: "border-sky-200", text: "text-sky-700", ring: "ring-sky-200" },
];

export const FEATURE_ICONS = {
  dashboard: LayoutDashboard, calendar: Calendar, weekly: CalendarDays,
  inventory: Package, workers: Users, "shift-types": Clock,
  "training-plans": Dumbbell, nutrition: Apple, anamnese: ClipboardList,
  bioimpedance: Activity, "social-media": Share2,
  "ai-chat": MessageSquare, statistics: BarChart3, integrations: Settings, crm: Users,
};

export const FEATURE_KEYS = {
  dashboard: "nav_dashboard", calendar: "nav_calendar", weekly: "nav_weekly",
  inventory: "nav_inventory", workers: "nav_workers", "shift-types": "nav_shift_types",
  "training-plans": "nav_training_plans", nutrition: "nav_nutrition", anamnese: "nav_anamnese",
  bioimpedance: "nav_bioimpedance", "social-media": "nav_social_media",
  "ai-chat": "nav_ai_chat", statistics: "nav_statistics", integrations: "nav_integrations", crm: "nav_crm",
};

export const UI_LABELS = {
  de: {
    opt: ["Option 1", "Option 2", "Option 3"],
    food: "Lebensmittel", weight: "Gewicht (g)", calories: "Kalorien",
    protein: "Protein", carbs: "Kohlenh.", fat: "Fett", total: "TOTAL",
    dayTotal: "Tagesgesamt", add: "Hinzufügen", search: "Lebensmittel suchen...",
    save: "Speichern", update: "Aktualisieren", noFood: "Keine Lebensmittel",
    clickAdd: "klicke", addBtn: "Hinzufügen", recipe: "Rezeptvorschläge",
    planName: "Plan-Name...", clientSearch: "Kunden suchen...",
    savedPlans: "GESPEICHERTE PLÄNE", newPlan: "Neuer Plan",
    generating: "Generiere...", aiGenerate: "KI-Plan generieren",
    pAbbr: "P", kAbbr: "K", fAbbr: "F",
    deleteConfirm: "Löschen?", saved: "Gespeichert", saving: "Speichern...",
    pdfDownloaded: "PDF heruntergeladen", shoppingList: "Einkaufsliste",
    editFood: "Lebensmittel bearbeiten", nameDE: "Name (DE)", namePT: "Name (PT)", nameEN: "Name (EN)",
    allCats: "Alle",
    portion: "Portion (g)", carbsG: "Kohlenh. (g)", fatG: "Fett (g)", proteinG: "Protein (g)",
    description: "Beschreibung (optional)", newFoodBtn: "Neues Lebensmittel", createFood: "Lebensmittel erstellen",
  },
  pt: {
    opt: ["Opção 1", "Opção 2", "Opção 3"],
    food: "Alimento", weight: "Peso (g)", calories: "Calorias",
    protein: "Proteína", carbs: "Carbos", fat: "Gordura", total: "TOTAL",
    dayTotal: "Total do Dia", add: "Adicionar", search: "Buscar alimento...",
    save: "Salvar", update: "Atualizar", noFood: "Nenhum alimento",
    clickAdd: "clique em", addBtn: "Adicionar", recipe: "Sugestões de Receitas",
    planName: "Nome do plano...", clientSearch: "Buscar cliente...",
    savedPlans: "PLANOS SALVOS", newPlan: "Novo Plano",
    generating: "Gerando...", aiGenerate: "Gerar Plano IA",
    pAbbr: "P", kAbbr: "C", fAbbr: "G",
    deleteConfirm: "Deletar?", saved: "Salvo", saving: "Salvando...",
    pdfDownloaded: "PDF baixado", shoppingList: "Lista de Compras",
    editFood: "Editar alimento", nameDE: "Nome (DE)", namePT: "Nome (PT)", nameEN: "Nome (EN)",
    allCats: "Todos",
    portion: "Porção (g)", carbsG: "Carbos (g)", fatG: "Gordura (g)", proteinG: "Proteína (g)",
    description: "Descrição (opcional)", newFoodBtn: "Novo Alimento", createFood: "Criar Alimento",
  },
  en: {
    opt: ["Option 1", "Option 2", "Option 3"],
    food: "Food", weight: "Weight (g)", calories: "Calories",
    protein: "Protein", carbs: "Carbs", fat: "Fat", total: "TOTAL",
    dayTotal: "Day Total", add: "Add", search: "Search food...",
    save: "Save", update: "Update", noFood: "No foods",
    clickAdd: "click", addBtn: "Add", recipe: "Recipe Suggestions",
    planName: "Plan name...", clientSearch: "Search client...",
    savedPlans: "SAVED PLANS", newPlan: "New Plan",
    generating: "Generating...", aiGenerate: "AI Generate Plan",
    pAbbr: "P", kAbbr: "C", fAbbr: "F",
    deleteConfirm: "Delete?", saved: "Saved", saving: "Saving...",
    pdfDownloaded: "PDF downloaded", shoppingList: "Shopping List",
    editFood: "Edit food", nameDE: "Name (DE)", namePT: "Name (PT)", nameEN: "Name (EN)",
    allCats: "All",
    portion: "Portion (g)", carbsG: "Carbs (g)", fatG: "Fat (g)", proteinG: "Protein (g)",
    description: "Description (optional)", newFoodBtn: "New Food", createFood: "Create Food",
  },
};
